import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/Login'),
    }, {
        path: '/secure/:cards?',
        name: 'secure',
        component: () => import('@/views/Secure'),
    }, {
        path: '/test',
        name: 'test',
        component: () => import('@/views/Test'),
    },
];

const router = new VueRouter({
    routes
});

export default router;
